import React from 'react';
import './SuccessPage.css';

function SuccessPage() {
  return (
    <div className="success-page">
      <div className="success-content">
        <div className="success-icon">✓</div>
        <h1>Спасибо!</h1>
        <p>Ваша заявка успешно отправлена</p>
        <p className="success-note">Мы свяжемся с вами в ближайшее время</p>
      </div>
    </div>
  );
}

export default SuccessPage; 